export function getText(phones) {
  return `${phones.length} ${
    phones.length > 1 ? 'profiles' : 'profile'
  } with same phone`
}
